import React from "react";
import Logo from "./Logo";
import { OPEN_CONSENT_EVENT } from "../../lib/analytics";

const FOOTER_LINKS = [
  { label: "About", href: "/about" },
  { label: "Blog", href: "/blog" },
  { label: "FAQ", href: "/faq" },
  { label: "Terms", href: "/terms" },
  { label: "Privacy", href: "/privacy" },
  { label: "Cookies", href: "/cookies" },
  { label: "Contact", href: "mailto:support@binshare.co.uk" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      className="bg-moss-950 text-cream-100/80 pt-16 pb-10 relative overflow-hidden"
      data-testid="footer"
    >
      <div
        className="absolute inset-0 opacity-[0.05] pointer-events-none"
        style={{
          backgroundImage:
            "radial-gradient(circle at 1px 1px, #F8F4ED 1px, transparent 0)",
          backgroundSize: "32px 32px",
        }}
      />
      <div className="absolute -bottom-32 -right-10 w-[420px] h-[420px] bg-sage-500/10 rounded-full blur-3xl pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <a
            href="/"
            className="inline-flex items-center gap-2.5 group"
            data-testid="footer-logo-link"
          >
            <Logo className="w-10 h-10" />
            <span className="font-display text-2xl font-bold tracking-tight text-cream-50">
              Binshare
            </span>
          </a>

          <nav
            className="flex flex-wrap items-center gap-x-8 gap-y-3"
            data-testid="footer-nav"
          >
            {FOOTER_LINKS.map((l) => (
              <a
                key={l.label}
                href={l.href}
                className="text-sm text-cream-100/70 hover:text-sage-300 transition-colors"
                data-testid={`footer-link-${l.label.toLowerCase()}`}
              >
                {l.label}
              </a>
            ))}
            <button
              type="button"
              onClick={() => window.dispatchEvent(new Event(OPEN_CONSENT_EVENT))}
              className="text-sm text-cream-100/70 hover:text-sage-300 transition-colors"
              data-testid="footer-cookie-settings"
            >
              Cookie settings
            </button>
          </nav>
        </div>

        <div className="mt-14 pt-8 border-t border-cream-50/10 flex flex-col-reverse md:flex-row gap-4 md:gap-6 justify-between md:items-center">
          <div className="text-xs text-cream-100/60 leading-relaxed max-w-2xl">
            <p data-testid="footer-tagline" className="text-cream-50 font-semibold text-sm">
              Proudly Welsh. Based near Llanberis, North Wales.
            </p>
            <p className="mt-2" data-testid="footer-copyright">
              © {year}{" "}
              <span className="text-cream-50 font-semibold">Binshare</span>. All
              rights reserved. Binshare Ltd, Company No. 16909547 — registered
              in England &amp; Wales.
            </p>
          </div>
          <div className="flex items-center gap-2 text-xs text-cream-100/60" data-testid="footer-live-status">
            <span className="w-1.5 h-1.5 bg-sage-400 rounded-full animate-pulse" />
            <span>Now live in North Wales and the North West</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
